export const url = "https://dev.ashrafigold.com/";
// export const baseUrl = `https://cors-anywhere.herokuapp.com/${url}api`
export const baseUrl = `${url}api`;

export const urls = {
  login: "/login",
  init: "/mobile/init",
  forgot: "/forget-password",
  verify: '/verification',
  register: "/register",
  logout: "/mobile/logout",
  getPrices: "/mobile/price",
  getChartsMenu: "/mobile/chart-menu",
  getChartsByType: "/mobile/chart?type=GOLD&time=",
  getArchiveByType: "/mobile/archive?type=GOLD&date=2020-09-10",
  getNews: "/mobile/news",
  getSubscriptions: "/mobile/subscription",
  getSubscriptionsInfo: "/mobile/subscription-info?duration=3&price=2000000",
  buySubscriptions: "/mobile/subscription-payment",
  changePass: "/mobile/change-password",
};
